module.exports = __webpack_public_path__ + "static/media/balance.13711d9c.gif";